import React, { Fragment, useEffect, useState } from 'react'
import { Card, CardBody, Row } from "reactstrap";
import { getAggregatorDataById } from '../../../Services/Shared.service';
import { H4, P } from "../../../AbstractElements";
import { TaskHeadings1 } from './Components/VendorProfileContent';
import moment from "moment";
import { BackgroundColor } from '../../../Constant';

const VendorDetails = () => {

  const [aggregatorData, setAggregatorData] = useState([]);
  const [aggregatorId, setAggregatorId] = useState(localStorage.getItem('vendorId') ? localStorage.getItem('vendorId') : null);

  useEffect(() => {
    getAggregatorDataById(aggregatorId).then((res) => {
      setAggregatorData(res.data);
    })
    console.log(">>>>>>> Aggregatore value in Vendor Details ", aggregatorId);
    console.log(">>>>>>> Aggregatore value in Vendor Data ", aggregatorData);
  }, [aggregatorId])

  return (
    <Fragment>
      <Card className="driver-details" style={{marginBottom:"5vh"}}>
        <CardBody>
          <Row className="driver-info">
            <Row>
              <div className="header-info">
                <h4 style={{
                  backgroundColor: "#313493", color: "white", width: "13vw", height: "3.8vh",
                  fontSize: "13px", textAlign: "center", alignContent: "center", borderRadius: "10px",
                }}>
                  VENDOR DETAILS
                </h4>
              </div>
            </Row>
            <Row>
              <div className="driver-info">
                <div className="driver-content">
                  <div className="table-responsive" style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between"
                  }}>
                    <table className="driver-list-table">
                      <thead>
                        <tr></tr>
                      </thead>
                      <tbody>
                        {TaskHeadings1.map((element, i) => {
                          let value = aggregatorData[element.value] ? aggregatorData[element.value] : '-'
                          if ((element.value == 'createdOn' || element.value == 'deletedOn' || element.value == 'updatedOn') && value !== '-') {
                            console.log(value, 'value');
                            value = moment(value).format('MMM DD,YYYY')

                            return (
                              <tr key={i}>
                                <td>
                                  <P>{element.name}</P>
                                </td>
                                <td>
                                  <P>{value}</P>
                                </td>
                              </tr>
                            );
                          }
                          return (
                            <tr key={i}>
                              <td>
                                <P>{element.name}</P>
                              </td>
                              <td>
                                <P>
                                  {
                                    aggregatorData[element.value] === true
                                      ? 'Yes'
                                      : aggregatorData[element.value] === false
                                        ? 'No'
                                        : aggregatorData[element.value] || aggregatorData[element.value] === 0
                                          ? aggregatorData[element.value]
                                          : '-'}
                                </P>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>

                </div>
              </div>

            </Row>
          </Row>
        </CardBody>
      </Card>
    </Fragment>
  )
}

export default VendorDetails